import React from 'react';
import { Select, SelectProps } from 'ui';
import { useIntl } from 'react-intl';
import { HeaderButtonType } from 'constants/enums';

interface PortalSectionSelectProps extends SelectProps {}

export const labelMap = {
  [HeaderButtonType.GEOPRODUCT]: 'navigation.geoproducts',
  [HeaderButtonType.PLANNED]: 'navigation.planned_documents',
  [HeaderButtonType.PARTICIPATION]: 'navigation.participation_budget',
};

const PortalSectionSelect = ({ name, label, validations }: PortalSectionSelectProps) => {
  const intl = useIntl();

  return (
    <Select
      options={Object.values(HeaderButtonType).map((code) => ({
        label: intl.formatMessage({ id: labelMap[code] }),
        value: code,
      }))}
      name={name}
      label={label}
      validations={validations}
      showSearch={false}
    />
  );
};

export default PortalSectionSelect;
